/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import ReactDOM from 'react-dom'

import Promise from 'promise-polyfill';
import 'normalize.css';

import 'styles/font-faces.css';
import 'styles/reset.css';
import 'styles/typography.css';
import 'styles/colors.css';
import 'styles/reboot.css';
import 'styles/layout-utility.css';

import App from 'components/app'

if (!window.Promise) {
  window.Promise = Promise;
}

ReactDOM.render(
  <App />, document.getElementById('app'),
)
